import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import Header from '../../Component/Header'
import Menu from '../../Component/Menu'
import Footer from '../../Component/Footer'
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import PaymnetServices from '../../PaymnentGtaeway/PaymnetServices'
import SubscriptionServices from './SubscriptionServices'
import Swal from 'sweetalert2'

const SubscriptionPackDetails = () => {
    const location = useLocation()
    const [data,setData] = useState()

    useEffect(()=>{
        console.log(location)
        setData(location.state.data)
    },[])

    const createPlan = (e) =>{
            console.log(e)
           const amountPaise = Math.round(Number(e.price) * 100);
           if (!amountPaise || amountPaise <= 0) {
               Swal.fire('','Invalid price','error')
               return;
           }
           let planreq = {
                period: data.enguagmenttype==="SAASMonthly"?"monthly":data.enguagmenttype==="SAASQuarterly"?"monthly":data.enguagmenttype==="SAASYearly"?"yearly":"",
                interval: data.enguagmenttype==="SAASQuarterly"?3:1,
                item: {
                    name: data.title,
                    amount: amountPaise,
                    currency: e.currency,
                    description: data.description
                },
            }
            PaymnetServices.CreatePlan(planreq).then(res=>{
                const resp = typeof res.data === "string" ? (()=>{ try { return JSON.parse(res.data); } catch { return {}; } })() : res.data;
                if(resp && resp.id){
                SubscriptionServices.CreateSubscriptionPlan(e.id,resp.id).then(()=>{
                    setData(prev => prev ? {...prev, subscriptionpricies: prev.subscriptionpricies.map(p => p.id===e.id ? {...p, planid: resp.id} : p)} : prev);
                    Swal.fire('','Razorpay Plan created: '+resp.id,'success');
                }).catch(err=>Swal.fire('','Failed to link plan: '+(err?.response?.data || err.message),'error'));
                }else{
                    const msg = resp?.error?.description || resp?.error || 'Failed to create Razorpay plan';
                    Swal.fire('',msg,'error')
                }
            }).catch(err=>Swal.fire('','Failed to create Razorpay plan: '+(err?.response?.data?.error || err.message),'error'))
    }

  return (
         
    <div>
        
    <Header />
     <Menu/>
    <div className="content-wrapper">  
      <div className="card">
        <ol className="breadcrumb float-sm-right">
          <li className="breadcrumb-item text-secondary">
            <Link to="/sales">Home</Link>
          </li>
          
          <li className="breadcrumb-item active">Subscriptions</li>
        </ol>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">              
          
             
                  <div className="card-body">
                    <div>
                        <div>
                        <Table>
                            <TableBody>
                                <TableRow>
                                    <TableCell>Title </TableCell>
                                    <TableCell>: {data?.title}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Description </TableCell>
                                    <TableCell>: {data?.description}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Enguagment Type </TableCell>
                                    <TableCell>: {data?.enguagmenttype}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Plan Benifits </TableCell>
                                    <TableCell>: {data?.planbenifits?JSON.parse(data?.planbenifits)?.toString():""}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                        </div>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Country</TableCell>
                                    <TableCell>Price</TableCell>
                                    <TableCell>Planid</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {data && data.subscriptionpricies && data.subscriptionpricies.length>0 && data.subscriptionpricies.map((e,i)=>
                                    <TableRow>
                                    <TableCell>{e.country}</TableCell>
                                    <TableCell><span className='text-xs'>{e.currency}</span>{e.price}</TableCell>
                                    <TableCell>{e.planid?e.planid:<button type='button' className='btn btn-sm hovbuttonColour' onClick={()=>createPlan(e)}>Create Plan</button>}</TableCell>
                                </TableRow>
                                ) }
                            </TableBody>
                        </Table>
                    </div>
                  </div>
                    {/* /.card */}
                  </div>
                  {/* /.col */}
                </div>
                {/* /.row */}
              </div>
              {/* /.container-fluid */}
            </section>
          </div>
        </div>
        <Footer/>  
      </div>        
  )
}

export default SubscriptionPackDetails